import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import Box from "@mui/joy/Box";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import { useSelector } from "react-redux";
import { selectUiState } from "store/UIStateStore/slice/selectors";

import { PageHeader } from "../PageHeader";
import { CustomDimensions } from "styles/theme/themes";
import useNprogress from "app/hooks/useNprogress";
import SidebarNav from "app/components/SidebarNav/SidebarNav";
import CardModalAlertMobile from "app/components/CardFeedback/CardModalAlertMobile";

interface Props {
  children?: any;
  description?: string;
  breadcrumbs?: {
    href?: string;
    text: string;
  }[];
  tabs?: {
    href?: string;
    text: string;
  }[];
  onTabChange?: (index: number) => void;
  showBackButton?: boolean;
}

export function PageBase(props: Props) {
  useNprogress()

  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box
        // Background page background set here. If empty not sure why default will be grey
        sx={{
          display: "flex",
          height: "100dvh",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "background.body",
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <PageHeader
            description={props.description}
            breadcrumbs={props.breadcrumbs || []}
            tabs={props.tabs}
            onTabChange={props.onTabChange}
            showBackButton={props.showBackButton}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            minHeight: 0,
            width: "100%",
            maxWidth: "100vw",
            overflow: "hidden",
          }}
        >
          <SidebarNav />
          <Box
            component="main"
            className="MainContent"
            sx={{
              flex: 1,
              display: "grid",
              flexDirection: "column",
              minWidth: 0,
              overflow: "auto",
              ml: {
                xs: 0,
              },
              width: "100%",
              maxWidth: "100vw", // Ensure content doesn't exceed viewport width
              boxSizing: "border-box", // Include padding in width calculation
              pr: { xs: 0, sm: 0 }, // Remove right padding on small screens
            }}
          >
            {props.tabs && (
              <Box
                borderBottom={1}
                borderColor="divider"
                sx={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box maxWidth={CustomDimensions.bodyMaxWidth}>
                  <Tabs
                    defaultValue={0}
                    sx={{
                      bgcolor: "transparent",
                      // position: 'absolute',
                      // bottom: 0,
                      // left: { xs: 2, md: 4 },
                    }}
                    onChange={(e, value) => {
                      // logEvent(analytics, 'tab_change', { tab: value });
                      if (props.onTabChange) {
                        props.onTabChange(value as number);
                      }
                    }}
                  >
                    <TabList
                      tabFlex={1}
                      size="sm"
                      sx={{
                        justifyContent: "left",
                        [`&& .${tabClasses.root}`]: {
                          fontWeight: "600",
                          flex: "initial",
                          color: "text.tertiary",
                          [`&.${tabClasses.selected}`]: {
                            bgcolor: "transparent",
                            color: "text.primary",
                            "&::after": {
                              height: "2px",
                              bgcolor: "primary.500",
                            },
                          },
                        },
                      }}
                    >
                      {props.tabs.map((tab, index) => (
                        <Tab
                          key={index}
                          sx={{
                            // borderRadius: `${CustomDimensions.cornerRadius} ${CustomDimensions.cornerRadius} 0 0`,
                            p: 1.5,
                            minWidth: "150px",
                          }}
                          indicatorInset
                          value={index}
                        >
                          {tab.text}
                        </Tab>
                      ))}
                    </TabList>
                  </Tabs>
                </Box>
              </Box>
            )}

            {props.children}
            {/* <Footer /> */}
          </Box>
        </Box>
        <CardModalAlertMobile/>
      </Box>
    </CssVarsProvider>
  );
}
